/* =============================================================================
   PRIME GARAGE SOLUTIONS — Scroll animation layer
   Lenis smooth scroll + GSAP ScrollTrigger. Garage door rolls UP to reveal the
   hero. Rich on desktop, lighter on mobile, fully disabled for reduced-motion.
   Degrades safely: if GSAP/Lenis are missing, content is shown via IO reveals.
   ========================================================================== */
(function () {
  "use strict";

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var hasGSAP = typeof window.gsap !== "undefined";
  var hasLenis = typeof window.Lenis !== "undefined";

  /* ---- Fallback reveal (also used under reduced-motion / no GSAP) --------- */
  function ioReveal() {
    var els = document.querySelectorAll(".reveal, .reveal-stagger, .reveal-mask");
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Section reveals are ALWAYS driven by IntersectionObserver + CSS transitions.
     This is decoupled from smooth-scroll and immune to scroll-jumps. */
  ioReveal();

  if (reduce || !hasGSAP) {
    return; /* CSS already puts the door open under reduced-motion */
  }

  var gsap = window.gsap;
  gsap.registerPlugin(window.ScrollTrigger);
  var ScrollTrigger = window.ScrollTrigger;

  /* ---- Lenis smooth scroll, wired to ScrollTrigger ------------------------ */
  if (hasLenis) {
    var lenis = new window.Lenis({ duration: 1.1, smoothWheel: true, touchMultiplier: 1.6 });
    lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
    window.__lenis = lenis; /* theme.js uses it for anchor scrolling */
  }

  /* ---- The garage-door hero ---------------------------------------------- */
  var door = document.querySelector(".garage-door");
  var mm = gsap.matchMedia();

  if (door) {
    /* Desktop: pin the hero and scrub the door open as you scroll. */
    mm.add("(min-width: 761px)", function () {
      gsap.set(door, { yPercent: 0 }); /* start closed */
      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".hero",
          start: "top top",
          end: "+=110%",
          scrub: 0.6,
          pin: true,
          anticipatePin: 1
        }
      });
      tl.to(door, { yPercent: -100, ease: "none" }, 0)
        .to(".door-lip", { opacity: 0, duration: 0.2 }, 0.75)
        .from(".hero-content > *", { y: 44, opacity: 0, stagger: 0.06, ease: "power2.out" }, 0.15)
        .to(".hero-scrollcue", { opacity: 0, duration: 0.15 }, 0);
    });

    /* Mobile: no pin — the door lifts on load, content settles in. */
    mm.add("(max-width: 760px)", function () {
      gsap.set(door, { yPercent: 0 });
      var tl = gsap.timeline({ delay: 0.25 });
      tl.to(door, { yPercent: -100, duration: 1.25, ease: "power3.inOut" })
        .from(".hero-content > *", { y: 30, opacity: 0, stagger: 0.08, ease: "power2.out" }, 0.6);
    });
  }

  /* ---- Subtle parallax (desktop only) ------------------------------------ */
  mm.add("(min-width: 761px)", function () {
    gsap.utils.toArray("[data-parallax]").forEach(function (el) {
      var amt = parseFloat(el.getAttribute("data-parallax")) || 12;
      gsap.fromTo(el, { yPercent: -amt / 2 }, {
        yPercent: amt / 2, ease: "none",
        scrollTrigger: { trigger: el, start: "top bottom", end: "bottom top", scrub: true }
      });
    });
  });

  window.addEventListener("load", function () { ScrollTrigger.refresh(); });
})();
